export interface SimpleStringResult {
  value: string
}
